import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getPatients = createAsyncThunk(
  "patients",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const postPatient = createAsyncThunk(
  "Postpatients",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/patients/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const updatePatient = createAsyncThunk(
  "updatePatient",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/patients/${params.id}/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const deletePatient = createAsyncThunk(
  "deletePatient",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/patients/${params.id}/`,
        params,
        config
      );
      return {
        data,
        id: params?.id,
      };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getPatientsCities = createAsyncThunk(
  "patientsCities",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/cities/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getPatientShippingAddresses = createAsyncThunk(
  "get_patient_shiping_address",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${params?.id}/shipping_addresses/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const postPatientShippingAddress = createAsyncThunk(
  "post_patient_shiping_address",
  async (params, { rejectWithValue }) => {
    const { id, ...rest } = params;
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/patients/${params?.id}/shipping_addresses/`,
        rest,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchPatientShippingAddress = createAsyncThunk(
  "patch_patient_shiping_address",
  async (params, { rejectWithValue }) => {
    const { id, addressId, ...restparams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/patients/${params?.id}/shipping_addresses/${addressId}/`,
        restparams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getPatient = createAsyncThunk(
  "get_patient",
  async (params, { rejectWithValue }) => {
    const { id, ...restParams } = params;
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${id}/`,
        { params: restParams },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getPatientTopProducts = createAsyncThunk(
  "get_patient_top_products",
  async (params, { rejectWithValue }) => {
    const { id, ...restParams } = params;
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${id}/top-products/`,
        { params: restParams },
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getPatientAlpineiqTimeline = createAsyncThunk(
  "get_patient_alpineiq_timeline",
  async (params, { rejectWithValue }) => {
    const { id } = params;
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${id}/alpineiq_timeline/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getPatientAlpineiqWallet = createAsyncThunk(
  "get_patient_alpineiq_wallet",
  async (params, { rejectWithValue }) => {
    const { id } = params;
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${id}/alpineiq_wallet/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
